var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNeo = function SvgNeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Neo_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 .4H0v31.2h32V.4Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Neo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M5.667.4h20.667A5.667 5.667 0 0 1 32 6.067v19.866a5.667 5.667 0 0 1-5.666 5.667H5.667A5.667 5.667 0 0 1 0 25.933V6.067A5.667 5.667 0 0 1 5.667.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACC6E6",
    d: "M32 22.133H0v.267h32v-.267ZM32 6.533H0V6.8h32v-.267ZM32 14.267H0v.267h32v-.267ZM30.41 29.867H1.59c.088.092.178.181.274.267h28.272l.275-.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACC6E6",
    d: "M8.134.4h-.267v31.2h.267V.4ZM16.134.4h-.267v31.2h.267V.4ZM24.134.4h-.267v31.2h.267V.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1473E6",
    d: "M5.112 22.451c-.14 0-.2-.027-.2-.2V8.558c0-.109.044-.165.162-.165h3.467c.175 0 .2.038.276.175 1.436 2.644 4.337 8.263 5.035 9.846h.022c-.029-.631-.075-1.258-.075-3.364V8.589c0-.135.06-.2.2-.2h2.4c.155 0 .21.06.21.215v13.64c0 .165-.06.207-.243.207h-3.1c-.176 0-.239-.04-.3-.162-1.19-2.378-4.44-8.378-5.337-10.691H7.6c.08 1.234.105 2.1.105 4.106v6.546c0 .14-.042.2-.179.2l-2.414.001ZM21.32 17.91c.107 1.216.982 2.225 3.071 2.225a6.778 6.778 0 0 0 2.648-.494c.07-.043.131-.023.131.1v2.037a.245.245 0 0 1-.144.267 7.42 7.42 0 0 1-3.3.611c-4.024 0-5.439-2.768-5.439-5.422 0-2.969 1.815-5.662 5.183-5.662a4.369 4.369 0 0 1 4.534 4.638c.013.478-.02.956-.1 1.428a.183.183 0 0 1-.172.168c-.732.084-1.47.117-2.207.1l-4.205.003Zm2.793-2.1c.36.012.722-.001 1.08-.04v-.142a1.754 1.754 0 0 0-1.838-1.7 2.019 2.019 0 0 0-2.047 1.884l2.805-.003Z"
  }))));
};
export default SvgNeo;